var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMediaDooh = function SvgMediaDooh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.833 4.94a.804.804 0 0 0 .808-.8c0-.44-.362-.798-.808-.798a.804.804 0 0 0-.809.799c0 .44.363.799.809.799M9.264 3.333c-3.719 0-6.731 2.982-6.731 6.662s3.014 6.662 6.731 6.662 6.731-2.981 6.731-6.662-3.012-6.662-6.73-6.662m.024 10.135a3.55 3.55 0 0 1-3.553-3.55c0-1.96 1.59-3.549 3.553-3.549a3.55 3.55 0 0 1 3.553 3.55c0 1.96-1.591 3.55-3.553 3.55",
    opacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.733 3.34H2.5v13.326h3.233z",
    opacity: 0.6
  })));
};
export default SvgMediaDooh;